import React from "react";
import {
  RISK_REPORT,
  HOME,
  USERS,
  COURSES,
  CERTIFICATE,
  MY_ACCOUNT,
  ADMINS,
  SITE_AND_ZONE,
  SUB_CONTRACTOR,
  REPORT,
  TRAINING_REPORT,
  STORE_MANAGEMENT,
  ORDER_MANAGEMENT,
  PRODUCT_CATEGORY,
  SAFETY_POINT_MANAGEMENT,
  REWARD_POINT_MANAGEMENT,
  USER_GROUP,
  BREACH_RECORD,
  COMPANY,
  ADVERTISEMENT,
  CONFIGURATION,
  SAFETY_POINT,
  REWARD_POINT,
  BLACKLIST,
  NOTIFICATION_TEMPLATE,
} from "./paths";

const RiskReport = React.lazy(() => import("views/RiskReport"));
const Home = React.lazy(() => import("views/Home"));
const Users = React.lazy(() => import("views/Users"));
const Courses = React.lazy(() => import("views/Courses"));
const Certificate = React.lazy(() => import("views/Certificate"));
const MyAccount = React.lazy(() => import("views/MyAccount"));
const Admins = React.lazy(() => import("views/Admins"));
const Configuration = React.lazy(() => import("views/Configuration"));
const SubContractor = React.lazy(() => import("views/SubContractor"));
const Report = React.lazy(() => import("views/Report"));
const TrainingReport = React.lazy(() => import("views/TrainingReport"));
const StoreManagement = React.lazy(() => import("views/StoreManagement"));
const OrderManagement = React.lazy(() => import("views/OrderManagement"));
const ProductCategory = React.lazy(() => import("views/ProductCategory"));
const PointManagement = React.lazy(() => import("views/PointManagement"));
const UserGroup = React.lazy(() => import("views/UserGroup"));
const ConstructionSite = React.lazy(() => import("views/ConstructionSite"));
const BreachRecord = React.lazy(() => import("views/BreachRecord"));
const Company = React.lazy(() => import("views/Company"));
const Advertisement = React.lazy(() => import("views/Advertisement"));
const SafetyPoint = React.lazy(() => import("views/SafetyPoint"));
const RewardPoint = React.lazy(() => import("views/RewardPoint"));
const Blacklist = React.lazy(() => import("views/Blacklist"));
const NotificationTemplate = React.lazy(() =>
  import("views/NotificationTemplate"),
);

const COMPONENTS = {
  [RISK_REPORT]: RiskReport,
  [HOME]: Home,
  [USERS]: Users,
  [COURSES]: Courses,
  [CERTIFICATE]: Certificate,
  [MY_ACCOUNT]: MyAccount,
  [ADMINS]: Admins,
  [CONFIGURATION]: Configuration,
  [SUB_CONTRACTOR]: SubContractor,
  [REPORT]: Report,
  [TRAINING_REPORT]: TrainingReport,
  [STORE_MANAGEMENT]: StoreManagement,
  [ORDER_MANAGEMENT]: OrderManagement,
  [PRODUCT_CATEGORY]: ProductCategory,
  [SAFETY_POINT_MANAGEMENT]: PointManagement,
  [REWARD_POINT_MANAGEMENT]: PointManagement,
  [USER_GROUP]: UserGroup,
  [SITE_AND_ZONE]: ConstructionSite,
  [BREACH_RECORD]: BreachRecord,
  [COMPANY]: Company,
  [ADVERTISEMENT]: Advertisement,
  [SAFETY_POINT]: SafetyPoint,
  [REWARD_POINT]: RewardPoint,
  [BLACKLIST]: Blacklist,
  [NOTIFICATION_TEMPLATE]: NotificationTemplate,
};

function getGrantedRoutes(grantedMenuItems) {
  return grantedMenuItems.reduce((acc, input) => {
    if (
      input.children &&
      Array.isArray(input.children) &&
      input.children.length > 0
    ) {
      input.children.forEach((e) => {
        const path = e.nestedPath ? `${e.path}/*` : e.path;

        if (!COMPONENTS[e.path]) {
          return;
        }

        acc.push({
          key: path,
          path,
          component: COMPONENTS[e.path],
        });
      });
      return acc;
    }

    if (!COMPONENTS[input.path]) {
      return acc;
    }

    return [
      ...acc,
      {
        key: input.path,
        path: input.nestedPath ? `${input.path}/*` : input.path,
        component: COMPONENTS[input.path],
      },
    ];
  }, []);
}

export default COMPONENTS;
export { getGrantedRoutes };
